import { render } from "./projectsAdmin.vue?vue&type=template&id=6adb32c4&scoped=true"
import script from "./projectsAdmin.vue?vue&type=script&lang=js"
export * from "./projectsAdmin.vue?vue&type=script&lang=js"

import "./projectsAdmin.vue?vue&type=style&index=0&id=6adb32c4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6adb32c4"]])

export default __exports__